import React, { useMemo } from 'react';
import './Descriptions.style.css';

const Descriptions = ({
  items = [],
  column = 2,
  style = {},
  align = 'center',
  ratio = [],
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const descriptionItem = useMemo(() => {
    let newItem = [];
    let arr = [];
    let arrCount = 0;
    items.forEach((_item) => {
      ++arrCount;
      let spanValue = _item.span ?? 1;
      if (spanValue < column) {
        if (arrCount === items.length) {
          spanValue = column - arr.length;
        }
      }
      arr.push({ ..._item, span: spanValue });

      let count = 0;
      arr.forEach((_arritem) => (count += parseInt(_arritem.span)));
      if (count === column) {
        newItem.push(arr);
        arr = [];
      }
    });

    return newItem;
  }, [items, column]);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <table className="description_layout" style={{ ...style }}>
      {ratio.length ? (
        <colgroup>
          {ratio.map((_item, _index) => (
            <col key={`col_${_index}`} style={{ width: `${_item}%` }} />
          ))}
        </colgroup>
      ) : null}
      <tbody>
        {descriptionItem.map((_item, _index) => (
          <tr key={`row_${_index}`}>
            {_item.map((_subitem, _subindex) => (
              <React.Fragment key={`col_${_index}_${_subindex}`}>
                <th style={{ ..._subitem.labelStyle }}>{_subitem.label}</th>
                <td
                  colSpan={_subitem.span > 1 ? _subitem.span * column - 1 : 1}
                  style={{ textAlign: align, ..._subitem.style }}
                >
                  {_subitem.children}
                </td>
              </React.Fragment>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Descriptions;
